<template>
  <div>
    <bottom-bar :hideBotton="zap"/>
    <div class="content" :class="{'c-zap': zap || modo_catalogo}">
      <div class="mt-2" v-if="!token">
        <perfil-cadastro isComponente="true"/>
      </div>

      <div class="container-fluid mt-3" v-if="usuario.nome_cliente">
        <div class="pb-4 pt-1 border-bottom">
          <h1 class="h6 mb-0 text-normal" :aria-label="'Nome do meu usuário: ' + usuario.nome_cliente">{{usuario.nome_cliente}}</h1>
          <small class="text-muted">Suas informações sempre estarão seguras conosco.</small>
        </div>

        <router-link :to="url + '/perfil/meus-dados'" class="d-flex border-bottom py-3 text-dark">
          <div class="pr-3">
            <icon name="perfil" class="text-muted" size="24"/>
          </div>
          <div class="flex-grow-1 align-self-center">Editar Dados</div>
          <div class="align-self-center pr-3">
            <i class="fa fa-angle-right text-muted"></i>
          </div>
        </router-link>

        <router-link class="d-flex border-bottom py-3 text-dark" :to="url + '/perfil/enderecos'" aria-label="Editar meus endereços" v-if="!sem_senha">
          <div class="pr-3">
            <icon name="address" class="text-muted" size="24"/>
          </div>
          <div class="flex-grow-1 align-self-center">Meus Endereços</div>
          <div class="align-self-center pr-3">
            <i class="fa fa-angle-right text-muted"></i>
          </div>
        </router-link>

        <div v-if="empresa.fidelidade">
          <router-link class="d-flex border-bottom py-3 text-dark" :to="url + '/perfil/meus-pontos'" aria-label="Editar meus pontos">
            <div class="pr-3">
              <icon name="pontos" class="text-muted" size="24"/>
            </div>
            <div class="flex-grow-1 align-self-center">Meus Pontos</div>
            <div class="align-self-center pr-3">
              <i class="fa fa-angle-right text-muted"></i>
            </div>
          </router-link>
          <router-link class="d-flex border-bottom py-3 text-dark" :to="url + '/perfil/meus-vouchers'" aria-label="Editar meus vouchers">
            <div class="pr-3">
              <icon name="cupom" class="text-muted" size="24"/>
            </div>
            <div class="flex-grow-1 align-self-center">Meus Vouchers</div>
            <div class="align-self-center pr-3">
              <i class="fa fa-angle-right text-muted"></i>
            </div>
          </router-link>
        </div>

        <router-link v-if="cartao_pagamento && !sem_senha" class="d-flex border-bottom py-3 text-dark" to="/perfil/meus-cartoes" aria-label="Editar meus cartões">
          <div class="pr-3">
            <icon name="card" class="text-muted" size="24"/>
          </div>
          <div class="flex-grow-1 align-self-center">Meus Cartões</div>
          <div class="align-self-center pr-3">
            <i class="fa fa-angle-right text-muted"></i>
          </div>
        </router-link>

        <router-link class="d-flex border-bottom py-3 text-dark" :to="url + '/notificacao'" aria-label="Notificações" v-if="origin === '1'">
          <div class="pr-3 text-muted">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512" fill="currentColor"><path d="M247.5 38.4c-3.7 1.7-7 5.2-8.4 8.9-.6 1.6-1.1 8.4-1.1 15.2v12.3l-4.2.7c-2.4.4-8.8 1.8-14.3 3.2-54 13.9-95.1 57-107.2 112.4-1.3 6-1.7 16.7-2.2 57.9-.5 44.6-.8 50.9-2.3 54.3-.9 2-7.4 9.5-14.3 16.6-13.9 14.4-17.7 20.6-19.7 32.6-3 18.1 7.4 36.8 25.2 45.4l7.5 3.6 38.1.3 38.1.3.6 7.5c2.6 29.8 25.7 56.3 55.8 63.8 8.6 2.1 25.2 2.1 33.8 0 30.1-7.5 53.2-34 55.8-63.9l.6-7.5h36.4c33.9 0 36.8-.1 42.4-2 7.7-2.6 12.9-5.9 18.5-11.8 9.1-9.5 13.6-23.5 11.7-36.1-1.9-11.9-4.8-16.7-19.3-31.5-7.1-7.4-13.8-15.1-14.8-17.3-1.5-3.4-1.8-9.4-2.3-54.3-.6-49.9-.6-50.6-3.2-61-14-57.2-58.9-100.5-115.9-111.6l-8.7-1.7-.3-13.8c-.3-14.9-.9-16.6-7.1-21.3-3.5-2.6-14.7-3.3-19.2-1.2m36.5 75.1c44.2 12.2 75.8 49.1 81 94.5.5 4.7 1 27.4 1 50.5 0 47.1.1 48.1 7 62 2.9 5.9 6.8 11.3 15.4 21 10.3 11.6 11.6 13.4 11.6 16.7 0 2.8-.6 4.2-2.6 5.7l-2.7 2.1-140.4-.2-140.5-.3-1.9-2.4c-4.1-5-2.9-7.4 10.4-21 12.5-12.9 16.4-18.7 20.9-30.8 2.1-5.5 2.2-8 2.9-56.3.6-46.4.8-51.2 2.7-59.3 10.5-44 45.1-76.5 90.1-84.8 2.5-.4 11.6-.6 20.1-.4 12.9.3 17.1.8 25 3m8.2 293c-1 11.5-9.5 23-21 28.7-6 3-7.5 3.3-15.2 3.3-7.2-.1-9.5-.5-14.8-2.9-12.7-5.8-22.8-21.5-21.3-32.9.1-.4 16.4-.6 36.3-.5l36.3.3z"/></svg>
          </div>
          <div class="flex-grow-1 align-self-center">Notificações</div>
          <div class="align-self-center pr-3">
            <i class="fa fa-angle-right text-muted"></i>
          </div>
        </router-link>

        <router-link class="d-flex border-bottom py-3 text-dark" :to="url + '/ajuda'" aria-label="Ajuda">
          <div class="pr-3">
            <icon name="help" class="text-muted" size="24"/>
          </div>
          <div class="flex-grow-1 align-self-center">Ajuda</div>
          <div class="align-self-center pr-3">
            <i class="fa fa-angle-right text-muted"></i>
          </div>
        </router-link>

        <a href="javascript:" aria-label="Fazer logout do aplicativo" class="d-flex py-3 text-dark" @click="logout" role="button">
          <div class="pr-3 text-muted">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512" fill="currentColor"><path d="M110.5 44.5C80 51.4 56.8 72.3 46.7 102l-3.2 9.5-.3 40.2-.3 40.3H85v-32.3c0-17.7.4-34.8 1-38.1 3-18.3 17.3-32.6 35.6-35.6 7.9-1.3 260.9-1.3 268.8 0 18.3 3 32.6 17.3 35.6 35.6 1.3 7.9 1.3 260.9 0 268.8-3 18.3-17.3 32.6-35.6 35.6-7.9 1.3-260.9 1.3-268.8 0-18.3-3-32.6-17.3-35.6-35.6-.6-3.3-1-20.4-1-38.2V320H43v37.2c0 40.7.4 44.1 5.9 58.3 4.1 10.7 10 19.5 19 28.6 9.1 9 17.9 14.9 28.6 19 16.1 6.2 8.2 6 162.8 5.7l141.2-.3 9.5-3.3c14.1-4.9 23.1-10.4 33-20.2 10-9.9 15.8-18.3 20.1-29.5 6.1-15.8 5.9-8.4 5.9-159.5s.2-143.7-5.9-159.5C458.8 85.3 453 76.9 443 67c-9.9-9.8-18.9-15.3-33-20.2l-9.5-3.3-142-.2c-116.4-.1-143.1.1-148 1.2"/><path d="M251 149.9c-4.2 1.4-8.4 3.8-10.7 6.3-5.4 5.7-6.9 16.7-3.4 23.6 1.1 2 13.2 14.9 27 28.7 13.8 13.7 25.1 25.3 25.1 25.7 0 .5-45.9.8-102 .8H85v42h102c56.1 0 102 .3 102 .8 0 .4-11.3 12-25.1 25.7-13.8 13.8-25.9 26.7-27 28.7-3.5 6.9-2 17.9 3.4 23.6 6 6.5 17.4 8.5 25.2 4.4 5-2.6 92.6-90.3 95.1-95.2 2.4-4.9 2.3-13.4-.4-18.5-2.5-4.9-90.3-92.6-94.9-94.9-4-2-10.9-2.8-14.3-1.7"/></svg>
          </div>
          <div class="flex-grow-1 align-self-center">Sair</div>
          <div class="align-self-center pr-3">
            <i class="fa fa-angle-right text-muted"></i>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import BottomBar from '../components/BottomBar'
  import LoginFacebook from '../components/auth/LoginFacebook';
  import Icon from "../components/Icon";
  import PerfilCadastro from "./PerfilDados";

  export default {
    name: 'Perfil',
    components: {PerfilCadastro, Icon, BottomBar, LoginFacebook},
    data() {
      return {
        token: localStorage.getItem('token'),
        url: ''
      }
    },

    methods: {
      logout() {
        this.$swal({
          text: 'Deseja realmente sair do sistema?',
          buttons: ["Não", "Sim"],
          dangerMode: true
        }).then((res) => {
          if (res) {
            this.$store.commit('logout');
            this.$router.push(this.url ? this.url : '/');

            if (typeof FB === 'function' && FB.getAccessToken()) {
              FB.logout();
            }
          }
        });
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      empresa() {
        return this.$store.state.empresa
      },

      cartao_pagamento() {
        return this.$store.state.cartao_pagamento
      },

      zap() {
        return this.$store.state.zap
      },

      sem_senha() {
        return this.$store.state.dataUser.sem_senha
      }
    },

    watch: {
      usuario(data) {
        if (data && data.token) {
          this.token = data.token;
        }
      }
    }
  }
</script>

<style scoped>

</style>
